(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/core/assets/javascripts/numbergames-collection.js') >= 0) return;  svs.modules.push('/components/numbergames/core/assets/javascripts/numbergames-collection.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.numbergames.core.NumbergamesCollection = Backbone.Collection.extend({
  create(model, options) {
    options = options ? _.clone(options) : {};
    const {
      wait,
      save,
      success
    } = options;
    model = this._prepareModel(model, options);
    if (!model) return false;
    if (!wait) this.add(model, options);
    const collection = this;
    options.success = function (m, resp, callbackOpts) {
      if (wait) collection.add(m, callbackOpts);
      if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
    };
    save ? model.save(null, options) : model.fetch(options);
    return model;
  },
  add(models, options) {
    if (options.parseCollection) {
      models = this.parse(models, options);
    }
    return this.set(models, _.extend({
      merge: false
    }, options, {
      add: true,
      remove: false
    }));
  },
  toArray() {
    return this.map(model => {
      var _model$toObject, _model$toObject2;
      return (_model$toObject = (_model$toObject2 = model.toObject) === null || _model$toObject2 === void 0 ? void 0 : _model$toObject2.call(model)) !== null && _model$toObject !== void 0 ? _model$toObject : _objectSpread({}, model.attributes);
    });
  }
});

 })(window);